/*
 * @Author: liangen liangen@oppo.com
 * @Date: 2022-06-06 10:16:01
 * @LastEditors: liangen(80398513)
 * @LastEditTime: 2024-06-12 15:27:14
 * @FilePath: /cem-portal-frontend/src/pages/Survey/SurveyManagement/components/SurveyContent/components/Topic/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {
  defineComponent,
  getCurrentInstance,
  onMounted,
  reactive,
  watch,
  nextTick,
  onUpdated
} from '@vue/composition-api'
import _ from 'lodash'
import './index.scss'
import MatrixContent from '../MatrixRadioTopic/MatrixContent'
import MatrixEdit from '../MatrixRadioTopic/MatrixEdit'
import RadioContent from '../RadioTopic/RadioContent'
import RadioEdit from '../RadioTopic/RadioEdit'
import CheckboxContent from '../CheckboxTopic/CheckboxContent'
import CheckboxEdit from '../CheckboxTopic/CheckboxEdit'
import SelectContent from '../SelectTopic/SelectContent'
import SelectEdit from '../SelectTopic/SelectEdit'
import MatrixCheckboxContent from '../MatrixCheckboxTopic/MatrixCheckboxContent'
import MatrixCheckboxEdit from '../MatrixCheckboxTopic/MatrixCheckboxEdit'
import FillContent from '../FillTopic/FillContent'
import FillEdit from '../FillTopic/FillEdit'
import SingLineEdit from '../SingleLineTopic/SingleLineEdit'
import SingLineContent from '../SingleLineTopic/SingLineContent'
import MultiLineContent from '../MultiLineTopic/MultiLineContent'
import MultiLineEdit from '../MultiLineTopic/MultiLineEdit'
import SectionEdit from '../SectionTopic/SectionEdit'
import SectionContent from '../SectionTopic/SectionContent'
import PageEdit from '../PageTopic/PageEdit'
import PageContent from '../PageTopic/PageContent'
import NpsEdit from '../NpsTopic/NpsEdit'
import NpsContent from '../NpsTopic/NpsContent'
import MatrixNpsContent from '../MatrixNpsTopic/MatrixNpsContent'
import MatrixNpsEdit from '../MatrixNpsTopic/MatrixNpsEdit'
import ScaleEdit from '../ScaleTopic/ScaleEdit'
import ScaleContent from '../ScaleTopic/ScaleContent'
import MatrixScaleContent from '../MatrixScaleTopic/MatrixScaleContent'
import MatrixScaleEdit from '../MatrixScaleTopic/MatrixScaleEdit'
import UploadContent from '../UploadTopic/uploadContent'
import UploadEdit from '../UploadTopic/uploadEdit'
import { PAGING_TOPIC_TYPE, TOPIC_DATA } from '../../config'
import { Message, MessageBox } from '@gcommon/gcommon-ui'
import VueI18n from 'vue-i18n'
import { tran } from '@/utils/assist'
import { sortByKey } from '../../util'
import ScoreRadioContent from '../ScoreRadioTopic/ScoreRadioContent'
import ScoreRadioEdit from '../ScoreRadioTopic/ScoreRadioEdit'
import CityTopicContent from '../CityTopic/CityTopicContent.vue'
import CityTopicEdit from '../CityTopic/CityTopicEdit'
import PhoneEdit from '../PhoneTopic/PhoneEdit'
import PhoneContent from '../PhoneTopic/PhoneContent'
import EmailContent from '../EmailTopic/EmailContent'
import EmailEdit from '../EmailTopic/EmailEdit'
const IS_NOT_SHOW_TITLE = [5, 15] //不需要展示题目标题的
const IS_SELECT_TYPE = [1, 2, 12, 3, 9, 20] //有选项的题
const IS_MATRIX_TYPE = [3, 9, 14, 18] //矩阵题
const NPS_TYPE = [17, 18, 8, 14] //需要校验最高、最低描述
const componentsMap = {
  MatrixContent,
  MatrixEdit,
  RadioContent,
  RadioEdit,
  CheckboxContent,
  CheckboxEdit,
  SelectContent,
  SelectEdit,
  MatrixCheckboxContent,
  MatrixCheckboxEdit,
  FillContent,
  FillEdit,
  SingLineContent,
  SingLineEdit,
  MultiLineContent,
  MultiLineEdit,
  SectionContent,
  SectionEdit,
  PageContent,
  PageEdit,
  NpsContent,
  NpsEdit,
  MatrixNpsContent,
  MatrixNpsEdit,
  ScaleContent,
  ScaleEdit,
  MatrixScaleContent,
  MatrixScaleEdit,
  UploadContent,
  UploadEdit,
  ScoreRadioContent,
  ScoreRadioEdit,
  CityTopicContent,
  CityTopicEdit,
  PhoneEdit,
  PhoneContent,
  EmailContent,
  EmailEdit
}
const Topic = defineComponent({
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    noHover: {
      type: Boolean,
      default: false
    },
    endBtnsWord: {
      type: String,
      default: tran('common.common')
    },
    order: {
      type: Number,
      default: 0
    },
    topics: {
      type: Array,
      default: () => []
    },
    isDraft: {
      type: Boolean
    },
    isViewAnswer: {
      type: Boolean,
      default: false
    },
    i18n: {
      type: VueI18n
    },
    config: {
      type: Object,
      default: () => {}
    },
    isAnswerBySms: {
      type: Boolean,
      default: false
    },
    outerNet: {
      type: Boolean,
      default: false
    },
    isShowBizId: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const vm = getCurrentInstance()
    const refs = context.refs as unknown as { formRef: FormRef }
    //i18n 国际化
    const tran = function (initParam) {
      return vm?.proxy.$t(initParam) as string
    }
    const { emit } = context
    const state = reactive({
      topicDetial: _.cloneDeep(props.item),
      isDraft: props.isDraft
    })

    watch(
      () => props.item,
      (val) => {
        state.topicDetial = _.cloneDeep(val)
      }
    )
    watch(
      () => props.isDraft,
      (val) => {
        state.isDraft = _.cloneDeep(val)
      }
    )

    /**
     *
     *点击删除题目
     */
    const deleteTopicClick = () => {
      MessageBox({
        type: 'warning',
        title: tran('common.sureDeltle'),
        message: tran('common.afterDelete'),
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: tran('common.sure'),
        cancelButtonText: tran('common.cancel'),
        callback: async (action, event) => {
          if (action === 'confirm') {
            emit('deleteTopic')
          }
        }
      })
    }

    /**
     *
     * 点击编辑题目
     */
    const editTopicClick = () => {
      //内部是否有选项随机排列
      if (props.item.topicSetting.isRandomOrder) {
        props.item.topicSetting.topicOptionSetting = sortByKey(
          props.item.topicSetting.topicOptionSetting,
          'optionOrder'
        )
      }
      state.topicDetial = props.item

      //需要判断有题处于编辑/新增状态
      if (
        props.topics.find((item) => item.isAddStatus || item.isEditStatus) ||
        props.config.isEditSumbitStatus ||
        props.config.isEditEndStatus
      ) {
        Message({
          message: tran('survy.needEdit'),
          type: 'warning'
        })
        return
      }
      emit(
        'completeEdit',
        Object.assign({}, _.cloneDeep(state.topicDetial), {
          isAddStatus: false,
          isEditStatus: true,
          isNeedSerive: false
        })
      )
    }

    /**
     *
     * 点击完成编辑
     * @return {*}
     */
    const completeEditClick = () => {
      //当是分页的时候，上下一项文案不能为空
      if (
        state.topicDetial.topicType === PAGING_TOPIC_TYPE &&
        (!state.topicDetial.topicSetting.lastPageText?.trim() ||
          !state.topicDetial.topicSetting.nextPageText?.trim())
      ) {
        Message.error(tran('survy.tbnoemp'))
        return
      }
      //需要做内容校验
      if (
        state.topicDetial.topicType !== PAGING_TOPIC_TYPE &&
        !state.topicDetial.topicName?.trim()
      ) {
        Message.error(tran('survy.topnoemp'))
        return
      }
      //当是矩阵题时，矩阵子题至少有一题，且每天题名不能为空
      if (IS_MATRIX_TYPE.indexOf(state.topicDetial.topicType) !== -1) {
        if (!state.topicDetial.matrixTopics.length) {
          Message.error(tran('survy.alestone'))
          return
        } else {
          let filterTopicOptions = state.topicDetial.matrixTopics.filter(
            (item) => {
              return !item.topicName?.trim()
            }
          )
          if (filterTopicOptions?.length > 0) {
            Message.error(tran('survy.alestnameone'))
            return
          }
        }
      }
      //当时NPS或者量标题时，需要检验最低、最高描述不能为空
      if (NPS_TYPE.indexOf(state.topicDetial.topicType) !== -1) {
        if (
          !state.topicDetial.topicSetting.minScoreDesc?.trim() ||
          !state.topicDetial.topicSetting.maxScoreDesc?.trim()
        ) {
          Message.error(tran('survy.lhnemp'))
          return
        }
        if (
          state.topicDetial.topicSetting.customizeOption &&
          !state.topicDetial.topicSetting.customizeOptionValue
        ) {
          Message.error(tran('survy.lhdiytext'))
          return
        }
      }
      //当时选择题时,不能没有选项，并且选项内容不能为空
      //当是单选跟多选时，可能只有图片，没有文字
      if (IS_SELECT_TYPE.indexOf(state.topicDetial.topicType) !== -1) {
        if (!state.topicDetial.topicSetting.topicOptionSetting.length) {
          Message.error(tran('survy.cholestone'))
          return
        } else {
          let filterTopicOptions =
            state.topicDetial.topicSetting.topicOptionSetting.filter((item) => {
              if ([1, 2, 20].indexOf(state.topicDetial.topicType) !== -1) {
                if (state.topicDetial.topicType === 20) {
                  return (
                    !item.optionName.trim() ||
                    (!item.scoreItem &&
                      item.scoreItem !== 0 &&
                      item.scoreItem !== '0')
                  )
                } else {
                  return !item.optionName.trim() && !item.imgSrc?.length
                }
              } else {
                return !item.optionName.trim()
              }
            })
          if (filterTopicOptions?.length > 0) {
            Message.error(tran('survy.chitnoemp'))
            return
          }
        }
      }

      //当时单、多选择题时,组合图片跟选项内容，该逻辑放置在校验是否有内容后
      if ([1, 2].indexOf(state.topicDetial.topicType) !== -1) {
        state.topicDetial.topicSetting.topicOptionSetting.forEach((element) => {
          // console.log(element)
          if (element.imgSrc?.length) {
            if (element.isImgFirst) {
              element.optionName = `<img src='${element.imgSrc[0].data}' style='width:32px; height:32px' />${element.optionName}`
            } else {
              element.optionName = `${element.optionName}<img src='${element.imgSrc[0].data}' style='width:32px; height:32px' />`
            }
          }
        })
      }

      // 当是城市题时，必须选择国家
      if (
        state.topicDetial.topicType === 21 &&
        !state.topicDetial.topicSetting.countryTopicOption
      ) {
        Message.error('区域国家不能为空')
        return
      }
      emit(
        'completeEdit',
        Object.assign({}, _.cloneDeep(state.topicDetial), {
          isAddStatus: false,
          isEditStatus: false,
          isNeedSerive: true
        })
      )
    }

    /**
     *
     * 点击取消编辑
     */
    const cancelEditClick = () => {
      if (props.item.isAddStatus) {
        emit('deleteTopic', true)
      } else {
        emit(
          'completeEdit',
          Object.assign({}, _.cloneDeep(props.item), {
            isAddStatus: false,
            isEditStatus: false,
            isNeedSerive: false
          })
        )
      }
    }

    /**
     *
     * 修改富文本框，改变源数据数组
     * @param {*} value
     */
    const changeTopicContent = (value) => {
      state.topicDetial = _.cloneDeep(value)
    }

    return () => {
      const dynComponent =
        TOPIC_DATA.filter((item) => {
          return item.value == state.topicDetial?.topicType
        })[0] || {}
      console.log(
        'dynComponent',
        dynComponent,
        state.topicDetial,
        TOPIC_DATA,
        props.item
      )
      const isNotNull = !props.item?.topicSetting?.isAllowNull
        ? `<i class='topic-title-not-null'>*</i>`
        : ''
      const isOrder = props.item?.isShowOrder
        ? `<span style='margin-right: 5px'>${props.item.order}.</span>`
        : ''
      const titleTips = props.item?.titleTips
        ? `<span class='title-tips'>${props.item.titleTips}</span>`
        : ''
      const titleError = props.item?.isShowTitleError
        ? `<span class='topic-title-error'>${props.item.titleErrorTips}</span>`
        : ''
      let isRadioCheckboxTips = ''
      let topicNameHtml = props.item?.topicName
      const reg = /^\<\w+\>(.+)\<\/\w+\>$/
      const topicNameList = topicNameHtml?.match(reg)
      if (topicNameList) {
        topicNameHtml = topicNameList.length > 0 ? topicNameList[1] : ''
      }
      const bizIdText = props.isShowBizId
        ? `<span class='topic-id-class'>(${tran('common.topicId')}: ${
            props.item?.bizId
          })</span>`
        : ''
      topicNameHtml = `<div style=display:flex ><div>${isNotNull}${isOrder}</div> <div style=flex:1 >${topicNameHtml}${bizIdText}</div></div>${isRadioCheckboxTips}${titleTips}${titleError}`

      const DynContentTag =
        componentsMap[dynComponent.contentComponent || 'RadioContent']
      const DynEditTag =
        componentsMap[dynComponent.editComponent || 'RadioEdit']

      const updateOtherTopicSmsEnable = (value) => {
        emit('updateOtherTopicSmsEnable', value)
      }
      return (
        <div>
          {!props.item?.isEditStatus && (
            <div
              ref={props.item.id}
              class={{
                'topic-content-item': true,
                'topic-content-item-hover':
                  !props.item?.isEditStatus && !props.noHover,
                'topic-content-item-edit': props.item?.isEditStatus
              }}>
              {IS_NOT_SHOW_TITLE.indexOf(props.item?.topicType) == -1 && (
                <div
                  class={{
                    'topic-title': true,
                    'topic-title-inline': props.isShowBizId
                  }}>
                  <div
                    style={{ width: '100%' }}
                    domPropsInnerHTML={topicNameHtml}></div>
                </div>
              )}
              <div
                class="topic-remark"
                domPropsInnerHTML={props.item?.topicSetting.topicRemark}></div>
              <div class="topic-content">
                <DynContentTag
                  isViewAnswer={props.isViewAnswer}
                  outerNet={props.outerNet}
                  isAnswerBySms={props.isAnswerBySms}
                  endBtnsWord={props.endBtnsWord}
                  i18n={props.i18n}
                  onpageTopicClick={(value) => emit('pageTopicClick', value)}
                  onanswer={(value) => emit('answer', value)}
                  item={props.item}></DynContentTag>
              </div>
              <div class="topic-item-edit-btns">
                <el-button
                  onClick={() => editTopicClick()}
                  type="success"
                  size="small"
                  style={{
                    border: 'none',
                    backgroundColor: 'transparent',
                    padding: '0',
                    fontSize: '20px'
                  }}
                  plain>
                  <i class="el-icon-edit"></i>
                  {/* {tran('survy.edit')} */}
                </el-button>
                <el-button
                  type="info"
                  onClick={() => deleteTopicClick()}
                  size="small"
                  style={{
                    border: 'none',
                    backgroundColor: 'transparent',
                    padding: '0',
                    fontSize: '20px'
                  }}
                  plain>
                  <i class="el-icon-delete"></i>
                  {/* {tran('survy.delete')} */}
                </el-button>
              </div>
            </div>
          )}
          {props.item?.isEditStatus && (
            <div
              // ref={props.item.id}
              // tabindex="-1"
              class="topic-edit-common">
              <DynEditTag
                onupdateOtherTopicSmsEnable={(value) =>
                  updateOtherTopicSmsEnable(value)
                }
                onchangeTopicContent={(value) => changeTopicContent(value)}
                item={props.item}
                topics={props.topics}
                isDraft={state.isDraft}></DynEditTag>
              <div class="topic-edit-content-item topic-edit-complete-btns">
                <el-button
                  type="success"
                  size="small"
                  style={{
                    border: 'none',
                    backgroundColor: 'transparent',
                    color: 'var(--primary)',
                    padding: '0',
                    fontSize: '24px'
                  }}
                  onClick={() => completeEditClick()}>
                  <i class="el-icon-check"></i>
                  {/* {tran('survy.finishedit')}  */}
                </el-button>
                <el-button
                  type="info"
                  size="small"
                  style={{
                    border: 'none',
                    backgroundColor: 'transparent',
                    padding: '0',
                    fontSize: '24px'
                  }}
                  onClick={() => cancelEditClick()}
                  plain>
                  <i class="el-icon-close"></i>
                  {/* {tran('survy.canceledit')}  */}
                </el-button>
              </div>
            </div>
          )}
        </div>
      )
    }
  }
})
export default Topic
